import { DestroyRef, inject, Injectable, signal, Signal, WritableSignal } from '@angular/core';

// Keep in sync with `$mobile-max-width` in libs/shared/ui/src/styles/@partou/breakpoints.scss.
export const MOBILE_MAX_WIDTH: Readonly<number> = 1024;

const MOBILE_QUERY: Readonly<string> = `(max-width: ${MOBILE_MAX_WIDTH - 1}px)`;

@Injectable({ providedIn: 'root' })
export class ViewportService {
  private destroyRef: DestroyRef = inject(DestroyRef);
  private _isMobile: WritableSignal<boolean>;

  constructor() {
    const query: MediaQueryList = window.matchMedia(MOBILE_QUERY);
    this._isMobile = signal(query.matches);
    const listener: (event: MediaQueryListEvent) => void = (event: MediaQueryListEvent): void => {
      this._isMobile.set(event.matches);
    };
    query.addEventListener('change', listener);
    this.destroyRef.onDestroy(() => query.removeEventListener('change', listener));
  }

  public get isMobile(): Signal<boolean> {
    return this._isMobile.asReadonly();
  }
}
